/*
Loads csv data for the practice and experiment trials. Renames columns, shuffles trials, as required. Sets the data to a struct and exports it as "corpus".
*/
import "../../../i18n/i18n";
import Papa from "papaparse"; //parsing csv file in browser
import "regenerator-runtime/runtime"; //async function
import { dashToCamelCase } from "../../shared/helpers";
import store from "store2"; //storing session data

const getItemFromBank = (current_item, item, corpusType) => {
  for (const property in item) {
    current_item[property] = item[property];
  }
  current_item["item_raw"] =
    current_item.operand1 +
    " " +
    current_item.operator +
    " " +
    current_item.operand2 +
    " =";
  if (store.session.get("config").taskName === "fluency-arf") {
    current_item[
      "item"
    ] = `<p class="item-stimulus" id="stimulus-val">${current_item.item_raw}<span class="spacing"><input type="text" name="question_input" id="question_input_key" class="item-textbox" style="text-align:center"></span></p>`;
  } else if (store.session.get("config").taskName === "fluency-calf") {
    current_item["item"] = `<span class="equation stacked" id="stimulus-val">
          <span class="number">${current_item.operand1}</span>
          <span class="operator">${current_item.operator}</span>
          <span class="number">${current_item.operand2}</span>
          <span class="equals">=</span><span class="textbox">
            <input type="text" name="question_input" id="question_input_key" class="item-textbox" style="text-align:right">
          </span>
        </span>`;

    if (corpusType === "practice") {
      current_item[
        "itemFeedbackIncorrect"
      ] = `<span class="equation-feedback stacked" id="stimulus-val">
                <span class="number">${current_item.operand1}</span>
                <span class="operator">${current_item.operator}</span>
                <span class="number">${current_item.operand2}</span>
                <span class="equals">=</span><span class="textbox">
                  <input type="text" name="question_input" id="question_input_key" class="item-textbox" style="text-align:right">
                </span>
              </span>`;
    }
  }
};

//takes array data and converts the labels for each row to a common naming convention
const transformCSV = (csvInput) => {
  let arr = [];
  for (var i = 0; i < csvInput.length; i++) {
    const newRow = {
      itemID: csvInput[i].ID,
      operand1: csvInput[i].number_a,
      operand2: csvInput[i].number_b,
      operator: csvInput[i].operator,
      target:
        csvInput[i].target ||
        csvInput[i].Target ||
        csvInput[i].answer ||
        csvInput[i].Answer,
      difficulty: csvInput[i].difficulty,
      audio: csvInput[i].audio,
    };

    //convert latex string to markup
    //newRow["item"] = katex.renderToString(newRow.item_raw, {
    //throwOnError: false,
    //});
    arr.push(newRow);
  }
  return arr;
};

//organises item list
const transformItemsCSV = (csvInput, difficultyIdx, start) => {
  let counter = 0;
  let prev_difficulty;
  let arr = [];
  for (var i = 0; i < csvInput.length; i++) {
    const newRow = {
      itemID: csvInput[i].ID,
      operand1: csvInput[i].number_a,
      operand2: csvInput[i].number_b,
      operator: csvInput[i].operator,
      target:
        csvInput[i].target ||
        csvInput[i].Target ||
        csvInput[i].answer ||
        csvInput[i].Answer,
      difficulty: csvInput[i].difficulty,
    };
    //get the starting positions of each difficulty bin
    if (i === 0) {
      start[newRow.difficulty] = i;
    } else if (newRow.difficulty != prev_difficulty) {
      //generate array (0,...,N-1) based on number of items in difficulty bin
      difficultyIdx[prev_difficulty] = Array.from(Array(counter).keys());
      counter = 0;
      start[newRow.difficulty] = i;
    }
    counter++;
    prev_difficulty = newRow.difficulty;
    if (i === csvInput.length - 1) {
      difficultyIdx[prev_difficulty] = Array.from(Array(counter).keys());
    }
    arr.push(newRow);
  }
  return arr;
};

//organises item ordering
const transformOrderCSV = (csvInput) => {
  let arr = [];
  let difficultyCount = {};
  for (var i = 0; i < csvInput.length; i++) {
    const newRow = {
      orderID: csvInput[i].ID,
      vectorID: csvInput[i].Vector,
      positionID: csvInput[i].PID,
      difficulty: csvInput[i].difficulty,
    };
    arr.push(newRow);
    //count the number of occurances of each difficulty bin
    if (newRow.difficulty in difficultyCount) {
      difficultyCount[newRow.difficulty]++;
    } else {
      difficultyCount[newRow.difficulty] = 1;
    }
  }
  return {
    arr: arr,
    difficultyCount: difficultyCount,
  };
};

//Returns and removes random value from array
const getRandomFromBucket = (bucket) => {
  var randomIndex = Math.floor(Math.random() * bucket.length);
  return bucket.splice(randomIndex, 1)[0];
};

export const fetchAndParseCorpusFluency = async (task, assets) => {
  let itemBank = {
    difficultyIdx: {},
    start: {},
    items: [],
  };
  let stimulusArray = {};
  let finalStimulusArray = [];
  let practiceStimulusArray = [];

  const corpusLocation = {
    fluencyArf: {
      order: {
        block0: `https://storage.googleapis.com/roam-fluency/shared/corpora/arf/items-order.csv`,
      },
      stimulus: `https://storage.googleapis.com/roam-fluency/shared/corpora/arf/items-all.csv`,
      practice: `https://storage.googleapis.com/roam-fluency/shared/corpora/arf/items-practice.csv`,
    },
    fluencyCalf: {
      order: {
        block0: `https://storage.googleapis.com/roam-fluency/shared/corpora/calf/items-order-phase1.csv`,
        block1: `https://storage.googleapis.com/roam-fluency/shared/corpora/calf/items-order-phase2.csv`,
        block2: `https://storage.googleapis.com/roam-fluency/shared/corpora/calf/items-order-phase3.csv`,
      },
      stimulus: `https://storage.googleapis.com/roam-fluency/shared/corpora/calf/items-all.csv`,
      practice: `https://storage.googleapis.com/roam-fluency/shared/corpora/calf/items-practice.csv`,
    },
  };

  const urls = corpusLocation[dashToCamelCase(task)];

  //uses Papa module for getting the csv from the url (results.data) and transforms the csv
  function downloadCSVPractice(url) {
    return new Promise((resolve, reject) => {
      Papa.parse(url, {
        download: true,
        header: true,
        complete: function (results) {
          practiceStimulusArray = transformCSV(results.data);
          resolve(results.data);
        },
        error: function (error) {
          reject(error);
        },
      });
    });
  }

  function downloadCSV(url) {
    return new Promise((resolve, reject) => {
      Papa.parse(url, {
        download: true,
        header: true,
        complete: function (results) {
          itemBank["items"] = transformItemsCSV(
            results.data,
            itemBank["difficultyIdx"],
            itemBank["start"],
          );
          resolve(results.data);
        },
        error: function (error) {
          reject(error);
        },
      });
    });
  }

  //for transforming the csv when it is a local file
  /*function downloadLocalCSV(data, i) {
    return new Promise((resolve, reject) => {
      stimulusArray.push(transformCSV(data));
      resolve(data);
    });
  }*/

  //call the function for transforming item list
  function downloadLocalCSV(data) {
    return new Promise((resolve, reject) => {
      itemBank["items"] = transformItemsCSV(
        data,
        itemBank["difficultyIdx"],
        itemBank["start"],
      );
      resolve(data);
    });
  }

  //call the function for transforming order list
  function downloadLocalCSVOrder(data) {
    return new Promise((resolve, reject) => {
      stimulusArray.push(transformOrderCSV(data));
      resolve(data);
    });
  }

  //gets data of each csv file and returns an array of promises
  //the csv data has already been assigned to practice and stimulus, which are outside the function
  /*async function parseMultipleLocalCSVsOrder(urls) {
    const promises = urls.map((url, i) => downloadLocalCSVOrder(url, i));
    return Promise.all(promises);
  }*/

  //call the function for transforming order list
  function downloadCSVOrder(urls, key) {
    return new Promise((resolve, reject) => {
      Papa.parse(urls[key], {
        download: true,
        header: true,
        complete: function (results) {
          stimulusArray[key] = transformOrderCSV(results.data);
          resolve(results.data);
        },
        error: function (error) {
          reject(error);
        },
      });
    });
  }

  async function parseMultipleCSVsOrder(urls) {
    const promises = urls.map((url, i) => downloadCSVOrder(url, i));
    return Promise.all(promises);
  }

  //pass csv paths into the parsing function and set the number of trials in session data
  async function fetchData() {
    try {
      await downloadCSV(urls["stimulus"]);
    } catch (error) {
      console.error("Error:", error);
    }

    for (var key in urls["order"]) {
      try {
        await downloadCSVOrder(urls["order"], key);
      } catch (error) {
        console.error("Error:", error);
      }
    }

    try {
      await downloadCSVPractice(urls["practice"]);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  await fetchData();

  //Generate the random indices for each stimulus array (order list) and difficulty bin
  for (var key in itemBank["difficultyIdx"]) {
    let idx_list = itemBank["difficultyIdx"][key].slice();
    for (var key2 in stimulusArray) {
      if (!stimulusArray[key2]["idxList"]) {
        stimulusArray[key2]["idxList"] = {};
      }
      if (stimulusArray[key2]["difficultyCount"][key]) {
        let rand_idx_list = [];
        for (var j = 0; j < stimulusArray[key2]["difficultyCount"][key]; j++) {
          rand_idx_list.push(
            getRandomFromBucket(idx_list) + itemBank["start"][key],
          );
        }
        stimulusArray[key2]["idxList"][key] = rand_idx_list;
      }
    }
  }

  //assign the final items based on the generated indices
  for (let i = 0; i < Object.keys(urls["order"]).length; i++) {
    let key = "block" + i;
    for (var j = 0; j < stimulusArray[key]["arr"].length; j++) {
      let difficulty = stimulusArray[key]["arr"][j]["difficulty"];
      let itemRandIdx = stimulusArray[key]["idxList"][difficulty].pop();
      let current_item = stimulusArray[key]["arr"][j];
      getItemFromBank(current_item, itemBank["items"][itemRandIdx], "main");
    }
    finalStimulusArray.push(stimulusArray[key]["arr"]);
  }

  for (var i = 0; i < practiceStimulusArray.length; i++) {
    let current_item = {};
    getItemFromBank(current_item, practiceStimulusArray[i], "practice");
    practiceStimulusArray[i] = current_item;
  }

  //set trial data to a struct, set name for later referencing
  let corpusAll = {
    stimulus: finalStimulusArray,
    practice: [practiceStimulusArray],
  };

  //add in introduction file for assets
  assets.default.languageSpecific.device.push(
    "introduction-" +
      store.session.get("config").taskName +
      "-" +
      store.session.get("config").labId +
      ".mp3",
  );

  store.session.set("corpusAll", corpusAll);
};
